import VerticalFlex from "layouts/flex/VerticalFlex";
import style from "./ArticleRegisterDetail.module.scss";
import { style as buttonStyle } from "components/buttons/AdminCustomButton";
import FlexChild from "layouts/flex/FlexChild";
import Center from "layouts/wrapper/Center";
import P from "components/P";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import { useEffect, useRef, useState } from "react";
import InputText from "components/inputs/InputText";
import NiceModal from "@ebay/nice-modal-react";
import { adminRequester } from "App";
import clsx from "clsx";
import InputNumber from "components/inputs/InputNumber";
import { useTranslation } from "react-i18next";
import { CButton, CSpinner } from "@coreui/react";
import Dummy from "components/Dummy";
import AdminQuillEditor from "components/inputs/richEditor/AdminQuillEditor";
import { toast } from "react-toastify";
import { textFormat } from "InitialData/regExp";
import AdminInputImage from "components/inputs/image/AdminInputImage";
import Container from "layouts/container/Container";
import FlexGrid from "layouts/flex/FlexGrid";
import AdminImageBlock from "components/inputs/image/AdminImageBlock";
import { useNavigate } from "react-router-dom";
import AdminCustomButton from "components/buttons/AdminCustomButton";
import Checkbox from "antd/lib/checkbox/Checkbox";
import DatePicker from "components/inputs/datePicker/DatePicker";
import { isDefaultBoardName } from "modals/article/BoardDetailModal";
import Inline from "layouts/container/Inline";
function ArticleRegisterDetail() {
  const { t } = useTranslation();
  const inputs = useRef([]);
  const [user, setUser] = useState();
  const [stores, setStores] = useState([]);
  const [store, setStore] = useState();
  const [regions, setRegions] = useState([]);
  const [region, setRegion] = useState();
  const [limitYn, setLimitYn] = useState(false);
  const [hideYn, setHideYn] = useState(false);
  const [isMounted, setMounted] = useState(false);
  const [isSpin, setSpin] = useState(false);
  const [boards, setBoards] = useState([]);
  const [board, setBoard] = useState();
  const [all, setAll] = useState(false);
  const [order, setOrder] = useState();
  const [item, setItem] = useState();
  const dateRef = useRef();
  const navigate = useNavigate();

  const onSaveClick = () => {
    if (!inputs.current[0].getValue()) {
      toast.error("제목은 필수 항목입니다.", {
        autoClose: 1000,
        position: toast.POSITION.BOTTOM_CENTER,
      });
    } else if (board?.name === "review" && (!order || !item)) {
      if (!order)
        toast.error("리뷰에는 주문서 선택이 필수 항목입니다.", {
          autoClose: 1000,
          position: toast.POSITION.BOTTOM_CENTER,
        });
      else if (!item)
        toast.error("리뷰에는 상품 선택이 필수 항목입니다.", {
          autoClose: 1000,
          position: toast.POSITION.BOTTOM_CENTER,
        });
    } else {
      setSpin(true);
      inputs.current[1].isValid().then(() => {
        const article = {};
        article.title = inputs.current[0].getValue();
        article.content = inputs.current[1].getValue();

        article.hidden = hideYn;
        if (limitYn) {
          article.start_date = dateRef.current.getStartDate();
          article.end_date = dateRef.current.getEndDate();
        }
        if (board?.name === "review") {
          article.order_id = order?.id;
          article.variant_id = item;
        }
        article.user_id = user?.id;
        article.board_id = board?.id;
        if (board?.name === "banner") {
          inputs?.current[3].isValid().then(() => {
            article.metadata = {
              link: inputs.current[2].getValue(),
              banner: inputs.current[3].getValue(),
            };
            adminRequester.createArticle(article, () => {
              navigate("/admin/articleStatus/all");
            });
          });
        } else
          adminRequester.createArticle(article, () => {
            navigate("/admin/articleStatus/all");
          });
      });
    }
  };

  useEffect(() => {
    if (isMounted) {
      adminRequester.getCurrentUser((result) => {
        const user = result.user;
        setUser(user);
        setStore(user.store_id);
      });
      adminRequester.getStores({}, (result) => setStores(result.stores));
      adminRequester.getRegions((result) => {
        const regions = result.regions;
        setRegions(regions);
        if (regions?.length > 0) setRegion(regions[0]);
      });
    }
  }, [isMounted]);
  useEffect(() => {
    if (store && region) {
      adminRequester.getBoards(
        all
          ? { store_id: null, region_id: null }
          : { store_id: store, region_id: region?.id },
        (result) => {
          const boards = result.boards;
          setBoards(boards);
          if (boards?.length > 0) setBoard(boards[0]);
        }
      );
      setOrder(null);
      setItem(null);
    }
  }, [region, store, all]);
  useEffect(() => {
    setMounted(true);
  }, []);

  const openOrder = () => {
    NiceModal.show("adminCheckSelect", {
      request: async (...props) => adminRequester.getOrders(...props),
      code: "orders",
      title: "주문서 목록",
      multiple: false,
      limit: 10,
      extraCondition: all
        ? { expand: "items.variant.product,customer" }
        : {
            expand: "items.variant.product,customer",
            region_id: region?.id,
            store_id: store,
          },
      headers: [
        { code: "id", label: "주문ID" },
        {
          code: "customer",
          Cell: ({ cell }) =>
            `${cell.first_name}${cell?.last_name ? ` ${cell.last_name}` : ""}`,
        },
        {
          code: "items",
          Cell: ({ row, cell }) => (
            <VerticalFlex key={row.id}>
              {cell?.map((item, index) => (
                <HorizontalFlex>
                  <FlexChild key={item?.id}>
                    <Inline>
                      <P>({index + 1}) </P>
                      <P>{item?.variant?.product?.title}</P>
                      <P> / </P>
                      <P>{item.variant.title}</P>
                    </Inline>
                  </FlexChild>
                </HorizontalFlex>
              ))}
            </VerticalFlex>
          ),
        },
      ],
      onSelect: (result) => setOrder(result[0]),
      Search: ({ callback }) => (
        <input
          type="text"
          onKeyDown={(e) => {
            if (e.key === "Enter") callback({ t: e.target.value });
          }}
          style={{
            outline: "none",
            backgroundColor: "rgb(233, 233, 233)",
            borderRadius: "10px",
            marginLeft: "auto",
            paddingRight: "10px",
            paddingLeft: "10px",
            minWidth: "250px",
          }}
          placeholder="search..."
        />
      ),
    });
  };
  return (
    <Container maxWidth={1500}>
      <VerticalFlex gap={20}>
        <FlexChild>
          <div className={style.container}>
            <VerticalFlex>
              <FlexChild>
                <div className={style.label}>
                  <Center width={"100%"} textAlign={"left"}>
                    <P>STEP 1. 게시글정보입력 </P>
                  </Center>
                </div>
              </FlexChild>
              <FlexChild>
                <div className={style.contentWrap}>
                  <VerticalFlex gap={20}>
                    <FlexChild>
                      <HorizontalFlex gap={40}>
                        <FlexChild width={"15%"}>
                          <P>스토어 설정</P>
                        </FlexChild>
                        <FlexChild>
                          <select
                            value={store}
                            onChange={(e) => {
                              setStore(e.target.value);
                            }}
                          >
                            {stores.map((store) => (
                              <option key={store.id} value={store.id}>
                                {store.name}
                              </option>
                            ))}
                          </select>
                        </FlexChild>
                      </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                      <HorizontalFlex gap={40}>
                        <FlexChild width={"15%"}>
                          <P>지역 설정</P>
                        </FlexChild>
                        <FlexChild>
                          <select
                            value={region?.id}
                            onChange={(e) => {
                              setRegion(
                                regions.find((r) => r.id === e.target.value)
                              );
                            }}
                          >
                            {regions.map((region) => (
                              <option key={region.id} value={region.id}>
                                {region.name}
                              </option>
                            ))}
                          </select>
                        </FlexChild>
                      </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                      <HorizontalFlex gap={40} justifyContent="flex-start">
                        <FlexChild width={"15%"}>
                          <P>전체글</P>
                        </FlexChild>
                        <FlexChild>
                          <input
                            type="checkbox"
                            style={{
                              display: "block",
                              width: 25,
                              height: 25,
                              cursor: "pointer",
                            }}
                            onChange={(e) => setAll(e.target.checked)}
                            checked={all}
                          />
                        </FlexChild>
                      </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                      <HorizontalFlex gap={40}>
                        <FlexChild width={"15%"}>
                          <P>게시판 설정</P>
                        </FlexChild>
                        <FlexChild>
                          <VerticalFlex flexStart gap={10}>
                            <FlexChild width="max-content">
                              <select
                                value={board?.id}
                                onChange={(e) => {
                                  setBoard(
                                    boards.find(
                                      (board) => board.id === e.target.value
                                    )
                                  );
                                }}
                              >
                                {boards.map((board) => (
                                  <option key={board.id} value={board.id}>
                                    {isDefaultBoardName(board?.name)
                                      ? t(board.name)
                                      : board.name}
                                  </option>
                                ))}
                              </select>
                            </FlexChild>
                            {board?.name === "review" ? (
                              <VerticalFlex gap={10}>
                                <FlexChild>
                                  <HorizontalFlex gap={10}>
                                    <FlexChild width="max-content">
                                      <AdminCustomButton
                                        text="주문 설정"
                                        style={buttonStyle.white_border}
                                        onClick={openOrder}
                                      />
                                    </FlexChild>
                                    {order && (
                                      <FlexChild>
                                        <P>선택한 주문ID : {order.id}</P>
                                      </FlexChild>
                                    )}
                                  </HorizontalFlex>
                                </FlexChild>
                                {order && (
                                  <FlexChild>
                                    <select
                                      defaultValue="-1"
                                      value={item}
                                      onChange={(e) => setItem(e.target.value)}
                                    >
                                      <option value="-1" disabled>
                                        상품을 선택해주세요
                                      </option>
                                      {order?.items
                                        ?.filter(
                                          (f) =>
                                            !f.free &&
                                            f.variant?.product?.store_id ===
                                              store
                                        )
                                        ?.map((item) => (
                                          <option
                                            key={item.id}
                                            value={item.variant.id}
                                          >{`${item.variant?.product?.title} / ${item.variant.title}`}</option>
                                        ))}
                                    </select>
                                  </FlexChild>
                                )}
                              </VerticalFlex>
                            ) : (
                              <></>
                            )}
                          </VerticalFlex>
                        </FlexChild>
                      </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                      <div className={style.line} />
                    </FlexChild>
                    <FlexChild>
                      <HorizontalFlex gap={40}>
                        <FlexChild width={"15%"}>
                          <P>제목</P>
                        </FlexChild>
                        <FlexChild>
                          <InputText
                            ref={(el) => (inputs.current[0] = el)}
                            name={"제목"}
                            placeHolder={"제목을 입력하세요."}
                            regExp={[textFormat]}
                            validable={false}
                          />
                        </FlexChild>
                      </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                      <HorizontalFlex gap={40}>
                        <FlexChild width={"15%"}>
                          <P>기간제한</P>
                        </FlexChild>
                        <FlexChild>
                          <HorizontalFlex justifyContent="flex-start" gap={15}>
                            <FlexChild width="max-content">
                              <input
                                type="checkbox"
                                style={{
                                  display: "block",
                                  width: 25,
                                  height: 25,
                                  cursor: "pointer",
                                }}
                                onChange={(e) => setLimitYn(e.target.checked)}
                                checked={limitYn}
                              />
                            </FlexChild>

                            <FlexChild width="max-content">
                              <DatePicker
                                ref={dateRef}
                                disabled={!limitYn}
                                maxDate={new Date("2999-12-31")}
                              />
                            </FlexChild>
                          </HorizontalFlex>
                        </FlexChild>
                      </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                      <HorizontalFlex gap={40}>
                        <FlexChild width={"15%"}>
                          <P>비밀글</P>
                        </FlexChild>
                        <FlexChild>
                          <FlexChild width="max-content">
                            <input
                              type="checkbox"
                              style={{
                                display: "block",
                                width: 25,
                                height: 25,
                                cursor: "pointer",
                              }}
                              onChange={(e) => setHideYn(e.target.checked)}
                              checked={hideYn}
                            />
                          </FlexChild>
                        </FlexChild>
                      </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                      <div className={style.line} />
                    </FlexChild>
                    {board?.name === "banner" && (
                      <FlexChild>
                        <HorizontalFlex gap={40}>
                          <FlexChild width={"15%"}>
                            <P>링크</P>
                          </FlexChild>
                          <FlexChild>
                            <FlexChild>
                              <InputText
                                ref={(el) => (inputs.current[2] = el)}
                                placeHolder="클릭시 이동할 주소를 입력해주세요."
                                regExp={[
                                  {
                                    exp: /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/,
                                  },
                                ]}
                                feedback={t("링크형태가 아닙니다.")}
                              />
                            </FlexChild>
                          </FlexChild>
                        </HorizontalFlex>
                      </FlexChild>
                    )}
                  </VerticalFlex>
                </div>
              </FlexChild>
            </VerticalFlex>
          </div>
        </FlexChild>
        <FlexChild>
          <div className={style.container}>
            <VerticalFlex>
              <FlexChild>
                <div className={style.label}>
                  <Center width={"100%"} textAlign={"left"}>
                    <P>STEP 2. 게시글 상세등록 </P>
                  </Center>
                </div>
              </FlexChild>
              <FlexChild>
                <div className={style.contentWrap}>
                  <VerticalFlex gap={15}>
                    {board?.name === "banner" && (
                      <FlexChild>
                        <HorizontalFlex gap={40}>
                          <FlexChild width={"15%"}>
                            <P>배너이미지</P>
                          </FlexChild>
                          <FlexChild>
                            <AdminInputImage
                              ref={(el) => (inputs.current[3] = el)}
                              name={"배너"}
                              path={"/article/banner"}
                              labelWidth={0}
                              cropWidth={1300}
                              cropHeight={520}
                              maxSizeMb={4}
                            />
                          </FlexChild>
                        </HorizontalFlex>
                      </FlexChild>
                    )}
                    <FlexChild height={"100%"}>
                      <HorizontalFlex gap={40}>
                        <FlexChild width={"15%"}>
                          <P>상세페이지</P>
                        </FlexChild>
                        <FlexChild height={"100%"}>
                          <div
                            style={{
                              maxWidth: "1200px",
                            }}
                          >
                            <AdminQuillEditor
                              ref={(el) => (inputs.current[1] = el)}
                              name={"상세"}
                            />
                          </div>
                        </FlexChild>
                      </HorizontalFlex>
                    </FlexChild>
                  </VerticalFlex>
                </div>
              </FlexChild>
            </VerticalFlex>
          </div>
        </FlexChild>
        <FlexChild>
          {isSpin && <CSpinner style={{ position: "absolute" }} />}
          <AdminCustomButton
            style={buttonStyle.white_border}
            text={"저장"}
            onClick={onSaveClick}
          />
        </FlexChild>
      </VerticalFlex>
    </Container>
  );
}

export default ArticleRegisterDetail;
